import React from 'react'

import {
  PlaygroundContractCrumbDocument,
  PlaygroundEmployeeCrumbDocument,
} from 'generated/resources/graphql'

import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/playground/pages/RootPage'))
const Index = React.lazy(() => import('modules/playground/pages/Index'))
const ContractPage = React.lazy(() => import('modules/playground/pages/breadcrumbs/ContractPage'))
const EmployeePage = React.lazy(() => import('modules/playground/pages/breadcrumbs/EmployeePage'))
const IndexPage = React.lazy(() => import('modules/playground/pages/breadcrumbs/IndexPage'))
const One = React.lazy(() => import('modules/playground/pages/one'))

export const playgroundRoutes = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      path: navigation.playground.path,
      element: <RootPage />,
      handle: {
        module: 'playground',
        moduleName: () => 'Playground',
        meta: () => ({
          title: 'Playground',
          description: 'This is the place where we play with stuff for no reason',
          subNavigation: [
            {
              index: true,
              href: navigation.playground.fullPath(),
              title: 'Breadcrumbs',
            },
            {
              href: navigation.playground.breadcrumbs.fullPath(),
              title: 'Breadcrumbs',
            },
            {
              href: navigation.playground.one.fullPath(),
              title: 'Factorial One',
            },
          ],
        }),
      },
      children: [
        {
          index: true,
          element: <Index />,
        },
        {
          path: navigation.playground.breadcrumbs.path,
          handle: {
            meta: () => ({
              title: 'Breadcrumbs',
              description: 'Do you want to see some breadcrumbs?',
            }),
          },
          children: [
            {
              index: true,
              element: <IndexPage />,
            },
            {
              path: navigation.playground.breadcrumbs.item.path,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PlaygroundEmployeeCrumbDocument,
                    variables: {
                      id: Number(params['employeeId']),
                    },
                  }).map((result) => ({
                    title: `${result?.data?.employees?.employee?.firstName}`,
                    description: 'Employee Info',
                  }))
                },
              },
              children: [
                {
                  index: true,
                  element: <EmployeePage />,
                },
                {
                  path: navigation.playground.breadcrumbs.item.subitem.path,

                  handle: {
                    meta: ({ params, watchQuery }) => {
                      return watchQuery({
                        query: PlaygroundContractCrumbDocument,
                        fetchPolicy: 'cache-first',
                        variables: {
                          id: Number(params['employeeId']),
                        },
                      }).map((result) => ({
                        title: `Contract: ${result?.data?.employees?.employee?.referenceContract?.jobTitle}`,
                        description: 'Yet another subitem!',
                      }))
                    },
                  },

                  element: <ContractPage />,
                },
              ],
            },
          ],
        },
        {
          path: navigation.playground.one.path,
          handle: {
            meta: () => ({
              title: 'Factorial One',
              description: 'Testing components from Factorial One',
            }),
          },
          children: [
            {
              index: true,
              element: <One />,
            },
          ],
        },
      ],
    }),
  ]
})
